<template>
  <component
    :is="is"
    class="invisible"
  >
    <slot/>
  </component>
</template>

<script>
  import dynamicComponent from '@/mixins/dynamic-component';

  export default {
    mixins: [dynamicComponent],
  };
</script>

<style
  scoped
  lang="scss"
>
  .invisible {
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
  }
</style>
